/* Pulse shop rail — the mobile quick-add sheet.

   A phone has no hover, so the Axel card's size run down the right edge can
   never be reached there. The card renders a cross instead (`quick_add` on
   snippets/pulse-product-card-axel.liquid) and this opens a sheet from the
   bottom of the screen with the colourways, the size grid and Add to bag.

   IT ADDS TO CART BY CLICKING THE CARD'S OWN SIZE BUTTON, and that is the whole
   design. assets/pulse-cards2.js already owns the correct add: it asks
   /cart/add.js for the re-rendered sections and hands them to
   <cart-drawer>.renderContents(), which repaints the drawer AND the bubble and
   opens the drawer. Re-implementing that here would be a second copy of the one
   piece of cart logic on this site that has already been got wrong once (the
   count incremented while the drawer stayed empty). Forwarding means there is
   still exactly one implementation, and the sheet cannot drift from the card.

   For the same reason the sheet's contents are CLONED from the card rather than
   rebuilt from data attributes: the title clone brings its `.cx2-w` / `.cx2-m`
   spans with it, so the Women's / Men's switch keeps working inside the sheet
   with no code here at all. */
(function () {
  if (window.__pulse_shop_rail) return;
  window.__pulse_shop_rail = true;

  function init(root) {
    if (!root || root.__psrSheetBound) return;
    root.__psrSheetBound = true;

    var sheet = root.querySelector('[data-psr-sheet]');
    if (!sheet) return;

    var panel = sheet.querySelector('[data-psr-panel]');
    var titleBox = sheet.querySelector('[data-psr-sheet-title]');
    var priceBox = sheet.querySelector('[data-psr-sheet-price]');
    var link = sheet.querySelector('[data-psr-sheet-link]');
    var colsBox = sheet.querySelector('[data-psr-sheet-cols]');
    var sizesBox = sheet.querySelector('[data-psr-sheet-sizes]');
    var sizeSel = sheet.querySelector('[data-psr-sizesel]');
    var scaleBtns = sheet.querySelectorAll('[data-psr-scale]');
    var addBtn = sheet.querySelector('[data-psr-sheet-add]');
    var addLabel = addBtn && addBtn.querySelector('[data-psr-add-label]');

    var sourceCell = null;   // the card the sheet was opened from
    var chosen = null;       // index into that card's size buttons
    var lastFocus = null;
    /* WP4-G (2026-09-06): the id of close()'s pending "now hide it" timer, so open() can cancel
       it. See close(). */
    var hideTimer = 0;
    var addWord = addBtn ? addBtn.getAttribute('data-label-add') || 'Add to bag' : '';
    var pickWord = addBtn ? addBtn.getAttribute('data-label-pick') || 'Select a size' : '';

    function setAddState() {
      if (!addBtn) return;
      addBtn.disabled = chosen === null;
      if (addLabel) addLabel.textContent = chosen === null ? pickWord : addWord;
    }

    function fill(cell) {
      sourceCell = cell;
      chosen = null;

      /* Clone, never re-render. The title carries the Women's / Men's spans and
         the size buttons carry both readings; cloning is what keeps the sheet
         on the same scale as the card without this file knowing the scale
         exists. */
      var title = cell.querySelector('.cx-meta__title');
      titleBox.textContent = '';
      if (title) titleBox.appendChild(title.cloneNode(true));

      var price = cell.querySelector('.cx-meta__price');
      priceBox.textContent = price ? price.textContent.trim() : '';

      var a = cell.querySelector('.cx-wall__link');
      if (link) {
        if (a) { link.href = a.getAttribute('href'); link.hidden = false; }
        else link.hidden = true;
      }

      /* Colourways. The card's bar is a stack of links to sibling products, so
         they stay links here -- tapping one is navigation, not selection, and
         it must not look like a size choice. */
      colsBox.textContent = '';
      var cols = cell.querySelectorAll('.cx2-colbar .cx2-col');
      colsBox.hidden = cols.length < 2;
      cols.forEach(function (col) {
        var chip = document.createElement('a');
        chip.className = 'psr-sheet__col' + (col.getAttribute('aria-current') ? ' is-on' : '');
        chip.href = col.getAttribute('href');
        chip.style.setProperty('--c', col.style.getPropertyValue('--c') || 'var(--line)');
        chip.title = col.getAttribute('title') || '';
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = col.textContent.trim();
        chip.appendChild(sr);
        colsBox.appendChild(chip);
      });

      /* ONE DROPDOWN, carrying the full US / UK / EU reading (Andre,
         2026-08-31 21:16). The option text is the card button's own
         data-label-m / data-label-w, which is the SAME string that becomes the
         cart line's `Size` property and prints on the order email -- so the
         customer reads one wording the whole way through. Nothing is composed
         here on purpose: UK is not on the variant, it comes from the size chart
         through snippets/pulse-size-label.liquid, and duplicating that lookup in
         JS is how the two would drift apart.

         The option VALUE stays the index into the card's real buttons, exactly
         as the old grid's data-psr-size did, so the add path below is unchanged:
         it still clicks the real button and lets pulse-cards2.js own the add. */
      buildOptions(cell);
      setAddState();
    }

    /* 'w' | 'm', from the one site-wide key. The sheet is a reader of it, never
       an owner: switching here also renumbers the wall behind the sheet and the
       size shown on every cart line. */
    function scale() {
      return window.PulseSizeScale ? window.PulseSizeScale.get() : 'w';
    }

    function labelFor(btn, sc) {
      return btn.getAttribute(sc === 'm' ? 'data-label-m' : 'data-label-w') || '';
    }

    function buildOptions(cell) {
      if (!sizeSel) return;
      var sc = scale();
      sizeSel.textContent = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = pickWord;
      ph.disabled = true;
      ph.selected = true;
      sizeSel.appendChild(ph);
      cell.querySelectorAll('.cx2-sizes .cx2-size').forEach(function (btn, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = labelFor(btn, sc);
        /* Parity with the grid this replaces: an unavailable size was disabled
           there too, so Notify is not reachable from the sheet either way. */
        if (btn.classList.contains('is-off')) opt.disabled = true;
        sizeSel.appendChild(opt);
      });
      syncScaleButtons();
    }

    /* Relabel in place rather than rebuild, so a size already chosen survives
       the customer flipping the toggle to check the other scale. */
    function relabel() {
      if (!sizeSel || !sourceCell) return;
      var sc = scale();
      var btns = sourceCell.querySelectorAll('.cx2-sizes .cx2-size');
      Array.prototype.forEach.call(sizeSel.options, function (opt) {
        if (opt.value === '') return;
        var btn = btns[Number(opt.value)];
        if (btn) opt.textContent = labelFor(btn, sc);
      });
      syncScaleButtons();
    }

    function syncScaleButtons() {
      var sc = scale();
      Array.prototype.forEach.call(scaleBtns, function (b) {
        var on = b.getAttribute('data-psr-scale') === sc;
        b.setAttribute('aria-pressed', String(on));
        b.classList.toggle('is-on', on);
      });
    }

    Array.prototype.forEach.call(scaleBtns, function (b) {
      b.addEventListener('click', function () {
        var next = b.getAttribute('data-psr-scale');
        if (window.PulseSizeScale) window.PulseSizeScale.set(next);
        else { syncScaleButtons(); relabel(); }
      });
    });

    /* Follows a switch made anywhere -- the rail's own control, a product page,
       another section -- not just the toggle inside this sheet. */
    if (window.PulseSizeScale && window.PulseSizeScale.onChange) {
      window.PulseSizeScale.onChange(function () { relabel(); });
    }

    if (sizeSel) {
      sizeSel.addEventListener('change', function () {
        chosen = sizeSel.value === '' ? null : Number(sizeSel.value);
        setAddState();
      });
    }

    function open(cell) {
      /* WP4-G (2026-09-06). close() schedules `sheet.hidden = true` 260ms out to let the slide
         finish. That timer used to be unstoppable, so reopening inside those 260ms -- a
         mis-tap on the scrim then straight back to the size, which is a normal thing to do --
         landed the stale callback on a sheet that was now OPEN: hidden went true under a panel
         mid-animation, and `psr-sheet-open` (which locks the page scroll) stayed on <html>.
         The customer was left on a page that would not scroll with nothing on screen to close.
         Cancel it first thing; it is only ever meaningful while the sheet is closing. */
      window.clearTimeout(hideTimer);
      hideTimer = 0;
      lastFocus = document.activeElement;
      fill(cell);
      /* PORTAL TO <body> ON FIRST OPEN (audit CSS-3, 2026-09-03). The sheet is
         rendered inside its section, inside <main>, and main is a stacking
         context (`.pulse > * { z-index: 1 }`), so the sheet's z-index of 70 only
         competed with main's own children: the fixed announcement bar (65) and
         nav (60) painted OVER the sheet, the scrim never dimmed them, and on a
         short viewport the panel's head sat under the nav. Same move the size
         drawer makes. Every reference this closure holds is to the element
         itself, so moving it changes nothing else; the CSS is namespaced with no
         ancestor selector, so it keeps applying. */
      if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
      sheet.hidden = false;
      /* Force the off-screen start state to be applied, THEN flip the class, so
         the browser has two distinct styles to transition between.

         A double requestAnimationFrame is the usual idiom and it is not safe
         here: measured 2026-08-31, inside an iframe the callbacks had not run
         700ms later, the class was never added and the panel stayed translated
         off the bottom of the screen. Reading offsetHeight forces a synchronous
         reflow instead, which cannot be deferred or throttled. */
      void panel.offsetHeight;
      sheet.classList.add('is-open');
      document.documentElement.classList.add('psr-sheet-open');
      if (panel) panel.focus();
      /* Contain focus while the sheet is open (audit T-23). Dawn's shared pair;
         the cart drawer uses the same one. */
      if (panel && typeof trapFocus === 'function') trapFocus(panel, panel);
    }

    function close() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('psr-sheet-open');
      var done = function () { hideTimer = 0; sheet.hidden = true; };
      /* Wait for the slide down, but never hang on a transitionend that a
         reduced-motion setting means will not fire.
         WP4-G: the id is kept so open() can cancel a close still in flight. */
      window.clearTimeout(hideTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { hideTimer = 0; done(); }
      else hideTimer = window.setTimeout(done, 260);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastFocus && lastFocus.focus ? lastFocus : null);
      else if (lastFocus && lastFocus.focus) lastFocus.focus();
      sourceCell = null;
      chosen = null;
      if (sizeSel) sizeSel.selectedIndex = 0;
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cx2-quick]');
      if (!trigger) return;
      e.preventDefault();
      var cell = trigger.closest('[data-cx2]');
      if (cell) open(cell);
    });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-psr-sheet-close]')) { close(); return; }

      /* The size grid is gone; the <select> has its own change handler. */
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (chosen === null || !sourceCell) return;
        var real = sourceCell.querySelectorAll('.cx2-sizes .cx2-size')[chosen];
        if (!real) return;
        /* Close first: the add re-renders the side cart and OPENS it, which is
           deliberate and approved behaviour, and two panels sliding over each
           other reads as a glitch. */
        close();
        real.click();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-psr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
